import { render, staticRenderFns } from "./PdfuploadForm.vue?vue&type=template&id=25337ec6"
import script from "./PdfuploadForm.vue?vue&type=script&lang=js"
export * from "./PdfuploadForm.vue?vue&type=script&lang=js"
import style0 from "./PdfuploadForm.vue?vue&type=style&index=0&id=25337ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports